
import { useSelector } from 'react-redux'

const useDetails = () => {
  return useSelector(state => state?.user?.details)
}

export default useDetails